import React from 'react';

import { VinculoEmpregaticioFeriasVencendoLista } from 'Component/VinculoEmpregaticio';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const FeriasVencendo = (): React.ReactElement => {
  const { data: { vinculos } = {} } = useRecuperarVinculosEmpregaticiosQuery({
    finder: 'feriasVencendo',
  });

  return (
    <div className="bg-white rounded shadow-sm">
      <div className="bg-primary text-white rounded-top py-2 px-3 fs-4 d-flex justify-content-between align-items-center">
        Férias para vencer
      </div>
      <div className="p-3 hf-500 overflow-auto rounded">
        {vinculos?.map((vinculo) => (
          <VinculoEmpregaticioFeriasVencendoLista
            key={`${vinculo.id}-${vinculo.modificado}`}
            dados={vinculo}
          />
        ))}
      </div>
    </div>
  );
};

export default FeriasVencendo;
